import {
    getActionPermissions,
    getAllResultParams, getDeleteResult, getItemActions,
    getItemCustomActionResult, getItemId,
    getItemLink, getItemView,
    getModelName, getModelTitle, getModelTooltip,
    getResultsValue,
    getSaveResult, getSingleTitle,
    getStartValues, getSubviewCount, getSubviews,
    getTitleColumn, getValueAdaptData, getValueAdaptSources,
    getNewRecordTitle
} from "~/stateGetter";
import {
    areValuesEqual, normalizeValueDependencies, onlyPersisted, prepareFieldValues, presentItemActionInfo,
    presentItemTitle, dropIgnoredFields
} from "~/statePresenter";
import {deleteItem} from "~/rx/model/deleteItem";
import {pushClose, pushCurrentModelPath, smartGoto} from "~/actions/navigation_actions";
import {saveItem} from "~/rx/model/saveItem";
import {connect} from "~/redux/connect";
import {performCustomItemAction, performCustomItemScanQrAction} from "~/rx/model/itemCustomAction";
import isEqual from 'lodash/isEqual';
import {getGroups, getPageAction, getSelectedRows} from "../../stateGetter";
import {compareKeys, diffKeys} from "mythil/object";
import identify from "~/identify";
import { getFitleredViewState } from "../../StateGetters/FilteredViewStateGetters";
import { replace } from 'redux-little-router';
import getConfig from "../../config";
import { mapValues } from "lodash";

const emptyObject = {};

const areMergedPropsEqual = (prev, curr) => {
    let isEqual  = _areMergedPropsEqual(prev, curr);

    if(!isEqual) {
        // console.log('ItemBar areMergedPropsEqual PERF', diffKeys(prev, curr));
    }

    return isEqual;
};

const _areMergedPropsEqual = (props, prevProps) => {
    return compareKeys(props, prevProps, (prop, prevProp, key) => {
        switch(key) {
            case 'actions':
                return isEqual(prop, prevProp);
            default:
                return prop === prevProp;
        }

    });
};

const areStatePropsEqual = (prev, curr) => {
    // let t1 = performance.now();

    let isEqual  = _areStatePropsEqual(prev, curr);

    // let t2 = performance.now();

    // if(!isEqual) {
    // console.log('GRID areStatePropsEqual PERF '+(t2 - t1), diffKeys(prev, curr));
    // }

    return isEqual;
};

const _areStatePropsEqual = (props, prevProps) => {
    return compareKeys(props, prevProps, (prop, prevProp, key) => {
        switch(key) {
            case 'valueAdaptSources':
            case 'selectedRows':
                return isEqual(prop, prevProp);
            default:
                return prop === prevProp;
        }

    });
};

const connectItemBar = connect(
    (state, { modelId }) => {
        if(!modelId) { return {}; }

        let props =  getValueAdaptData(state, modelId),
            itemId = getItemId(state, modelId);

        props.valueAdaptSources = getValueAdaptSources(state, modelId);

        let subviews = itemId !== identify.NEW_ITEM ?
            getSubviews(state, modelId) :
            emptyObject;

        props = {
            ...props, subviews,
            ...getAllResultParams(state, modelId),
            
            modelAction: getPageAction(state, modelId),
            groups: getGroups(state, modelId),
            startValues: getStartValues(state, modelId),
            singleTitle: getSingleTitle(state, modelId),
            modelTitle: getModelTitle(state, modelId),
            newRecordTitle: itemId === identify.NEW_ITEM ? getNewRecordTitle(state, modelId) : '',
            view: getItemView(state, modelId),
            saveResult: getSaveResult(state, modelId),
            resultsValue: getResultsValue(state, modelId),
            deleteResult: getDeleteResult(state, modelId),
            itemCustomActionResult: getItemCustomActionResult(state, modelId),
            actions: getItemActions(state, modelId),
            actionPermissions: getActionPermissions(state, modelId),
            itemLink: getItemLink(state, modelId),
            titleColumn: getTitleColumn(state, modelId),
            subviewCount: getSubviewCount(state, modelId),
            saveTooltip: getModelTooltip(state, modelId, 'save'),
            continueTooltip: getModelTooltip(state, modelId, 'continue'),
            editTooltip: getModelTooltip(state, modelId, 'edit'),
            deleteTooltip: getModelTooltip(state, modelId, 'delete'),
            actionsTooltip: getModelTooltip(state, modelId, 'actions'),
            selectedRows: getSelectedRows(state, modelId)
        };

        return props;
    },

    (dispatch, { modelId, gridName: gridNameProp }) => {
        const push = (path, options = {}, routeOptions = {}) => {
            dispatch(pushCurrentModelPath(path, options, { persistQuery: true, ...routeOptions }))
        }

        const getModelPath = (state) => {
            return `/${getModelName(state, modelId)}/${getItemId(state, modelId)}`
        }
        
        const listEntries = () => {
            return (dispatch, getState) => {
                return dispatch(pushClose({ forceChangeRootModel: true }))
            }
        }

        return {
            viewEntry: () => dispatch((dispatch, getState) => push(getModelPath(getState()))),
            saveItem: () => dispatch(saveItem(modelId, gridNameProp)),
            deleteItem: () => dispatch(deleteItem(modelId)),
            executeAction: (actionName, gridName, ...tags) => dispatch(performCustomItemAction(modelId, actionName, undefined, gridNameProp || gridName, tags)),
            executeScanQrAction: (actionName, data, gridName) => dispatch(performCustomItemScanQrAction(modelId, actionName, data, gridNameProp || gridName)),
            listEntries: () => dispatch(listEntries()),
            smartGoto: (href) => dispatch(smartGoto(href)),
            onCloseAction: () => dispatch((_, getState) => {
                if (!getPageAction(getState(), modelId)) return;
                dispatch(replace({ path: "", query: {} }, {  forceChangeRootModel: false }))
            }),
        }
    },

    (props, dispatchProps, ownProps) => {
        if(!ownProps.modelId) { return {...ownProps, ...props, ...dispatchProps}; }

        let {
            actionPermissions,
            view,
            itemId,
            itemLink,
            subviewCount,
            saveTooltip,
            editTooltip,
            actionsTooltip,
            continueTooltip,
            modelAction,
        } = props;

        let {
            viewEntry,
            saveItem,
            executeAction,
            executeScanQrAction,
            listEntries,
            deleteItem,
            smartGoto,
            onCloseAction,
        } = dispatchProps;

        let {
            loading,
            modelId,
            canClose,
            trans,
            size,
        } = ownProps;

        props = { ...props, ...props.valueAdaptSources };
        props = { ...props,  ...normalizeValueDependencies(props) };
        props = { ...props, ...dropIgnoredFields(onlyPersisted(props.editFields)) };

        let values = prepareFieldValues(props.editFields, props),
            startValues = prepareFieldValues(props.editFields, { ...props, editFieldValues: props.startValues });

        let openItemLink = null;
        if(itemLink) {
            openItemLink = () => smartGoto(itemLink);
        }

        const isDirty = !areValuesEqual(values, startValues);
        if (isDirty && getConfig().LOG_DIRTY_FIELDS) {
            const diff = diffKeys(values, startValues, isEqual);
            console.table([mapValues(diff, "a.value"), mapValues(diff, "b.value")]);
        }

        return {
            canClose,
            modelAction,
            size,
            saveTooltip, editTooltip, actionsTooltip, continueTooltip, view, loading, modelId, itemId, subviewCount, actionPermissions,
            ...presentItemActionInfo({...props, deleteItem, openItemLink, executeAction, executeScanQrAction, trans, saveItem, isDirty, view, subviewCount }),
            title: presentItemTitle(props),
            isDirty,
            viewEntry,
            saveItem,
            listEntries,
            onCloseAction,
            newRecordTitle: props.newRecordTitle,
        }
    }, { areMergedPropsEqual, areStatePropsEqual }
);

export default connectItemBar;